<dx-toolbar class="panel-toolbar" (onContentReady)="onContentReady($event)">
  <!-- Tam ekran: her sekmenin ilk başlığında (TamEkranService).
       Öğe hep yerinde kalır, yalnız içi *ngIf'li: dxi-item'ı *ngIf ile sonradan eklemek DevExtreme araç çubuğunu
       baştan çizdiriyor ve diğer öğelerdeki dx-button'ların içi boşalıyordu (Tahsilat Girişi işlem düğmeleri).
       span sabit kalmalı: içinde yalnız *ngIf olan dxi-item'ı DevExtreme boş öğe sayıp sonradan gelen içeriği göstermiyor. -->
  <dxi-item location="before" locateInMenu="never">
    <span class="tam-ekran-yeri"><ng-container *ngIf="(tamEkran.sahipler$ | async)?.has(el.nativeElement)"><dk-tam-ekran-dugmesi></dk-tam-ekran-dugmesi><dk-yardim-dugmesi></dk-yardim-dugmesi></ng-container></span>
  </dxi-item>
  <dxi-item location="before" locateInMenu="never">
    <div class="header-title">{{ headerText }}</div>
  </dxi-item>
  <dxi-item [location]="panelItemPosition" locateInMenu="auto">
    <ng-container *ngIf="panelItems">
      <dx-tabs
        [stylingMode]="'secondary'"
        keyExpr="key"
        [width]="(screen.xSmallScreenChanged | async) ? 150 : (tabWidth? tabWidth:'auto')"
        [showNavButtons]="false"
        [scrollByContent]="true"
        [selectedItemKeys]="selectedPanelItems"
        [items]="panelItems"
        (onSelectionChanged)="selectedPanelItemChanged.emit($event.addedItems[0])"
      ></dx-tabs>
    </ng-container>
  </dxi-item>


  <dxi-item location="before" locateInMenu="never">
    <ng-content select=".beforeCustom"></ng-content>
  </dxi-item>

  <dxi-item location="center" locateInMenu="never">
    <ng-content select=".centerCustom"></ng-content>
  </dxi-item>

  <dxi-item location="after" locateInMenu="never">
    <ng-content select=".afterCustom"></ng-content>
  </dxi-item>
 <ng-container *ngIf="!twoLineEnable">
  <ng-container *ngIf="locateInMenu && dynamicButtons && showDynamicButtons">
    <dxi-item location="after" locateInMenu="auto" *ngFor="let dynamicButton of dynamicButtons; trackBy: trackByFn">
      <div class="dynamic-button-container">
        <dx-button
          [style]="dynamicButton?.style"
          id="dynamicButtonTop"
          [disabled]="dynamicButton?.disabled ? true : dynamicButton?.donemKontrolYn ? (!donemAktif || !ambarAktif) : false"
          [text]="dynamicButton?.text"
          [icon]="dynamicButton.icon"
          [type]="dynamicButton.type"
          [hint]="dynamicButton.hint"
          [width]="dynamicButton.width ? dynamicButton.width : 'auto'"
          [stylingMode]="dynamicButton.stylingMode"
          (click)="handleDynamicButtonClick(dynamicButton)"
        ></dx-button>
      </div>
    </dxi-item>
  </ng-container>
  <ng-container *ngIf="!locateInMenu">
    <dxi-item location="after" locateInMenu="never">
      <div class="dynamic-button-container" *ngIf="dynamicButtons && showDynamicButtons">
        <ng-container *ngFor="let dynamicButton of dynamicButtons; trackBy: trackByFn">
          <dx-button
            [style]="dynamicButton?.style"
            [disabled]="(dynamicButton?.disabled ) || (dynamicButton?.donemKontrolYn ? (!donemAktif || !ambarAktif) : false)"
            [text]="dynamicButton?.text"
            [icon]="dynamicButton.icon"
            [type]="dynamicButton.type"
            [hint]="dynamicButton.hint"
            [width]="dynamicButton.width ? dynamicButton.width : 'auto'"
            [stylingMode]="dynamicButton.stylingMode"
            (click)="handleDynamicButtonClick(dynamicButton)"
          ></dx-button>
        </ng-container>
      </div>
    </dxi-item>
  </ng-container>
 </ng-container>

  <dxi-item location="after" locateInMenu="never">
    <ng-container *ngIf="newAddMenuElement">
      <dx-drop-down-button
        icon="plus"
        text="{{newAddMenuText?newAddMenuText:'Ekle'}}"
        displayExpr="name"
        keyExpr="id"
        type="default"
        stylingMode="contained"
        [disabled]="disable"
        [items]="newAddMenuElement"
        (onItemClick)="handleNewAddClick($event)"
        class="new-add-menu-button"
      >
      </dx-drop-down-button>
    </ng-container>

  </dxi-item>

  <dxi-item location="after" locateInMenu="never">
    <ng-container *ngIf="headerNewButton">
      <dx-button
        [disabled]="(headerNewButton?.disable ?? false) || !donemAktif || !ambarAktif"
        [text]="headerNewButton.name"
        icon="plus"
        type="default"
        stylingMode="contained"
        (click)="showAdd.emit()"
      ></dx-button>

    </ng-container>
  </dxi-item>
  <dxi-item location="after" locateInMenu="never">
    <ng-container *ngIf="actionMenuElement">
      <dx-drop-down-button
        [disabled]="actionMenuElement[0]?.disable"
        icon="menu"
        text="İşlemler"
        displayExpr="name"
        keyExpr="value"
        [dropDownOptions]="{ width: 'auto', minWidth:'6.5rem' }"
        [items]="actionMenuElement"
        (onItemClick)="handleItemClick($event)"
        class="rounded-full">
      </dx-drop-down-button>
    </ng-container>
  </dxi-item>

  <dxi-item location="after" locateInMenu="never">
    <ng-container *ngIf="this.selectedPeriodId && this.selectBoxConfig">
      <dx-select-box
        [style.max-width.px]="300"
        [width]="selectBoxConfig?.width ? selectBoxConfig?.width:(selectBoxConfig?.displayExpr ==='Ad'?'150px':selectBoxConfig?.displayExpr ==='Donem'?'100px':'auto')"
        [dataSource]="selectBoxConfig?.donemDataSource"
        [valueExpr]="selectBoxConfig?.valueExpr"
        [displayExpr]="selectBoxConfig?.displayExpr"
        [value]="selectedPeriodId"
        placeholder="Dönem Seçiniz"
        (selectedItemChange)="handlePeriodChange.emit($event)">
      </dx-select-box>
    </ng-container>
  </dxi-item>
  <dxi-item location="after" locateInMenu="never">
    <dx-button *ngIf="!hideCloseButton"
               [text]="closeButton.name"
               icon="close"
               type="danger"
               stylingMode="contained"
               (click)="closePageButton($event)"
    ></dx-button>
  </dxi-item>
</dx-toolbar>


<ng-container *ngIf="twoLineEnable">
  <dx-toolbar class="second-line-toolbar">
    <ng-container *ngIf="locateInMenu && dynamicButtons && showDynamicButtons">
      <dxi-item location="center" locateInMenu="auto" *ngFor="let dynamicButton of dynamicButtons; trackBy: trackByFn">
        <div class="dynamic-button-container">
          <dx-button
            [style]="dynamicButton?.style"
            id="dynamicButtonBottom"
            [disabled]="dynamicButton?.donemKontrolYn ? (!donemAktif || !ambarAktif) : false"
            [text]="dynamicButton?.text"
            [icon]="dynamicButton.icon"
            [type]="dynamicButton.type"
            [hint]="dynamicButton.hint"
            [width]="dynamicButton.width ? dynamicButton.width : 'auto'"
            [stylingMode]="dynamicButton.stylingMode"
            (click)="handleDynamicButtonClick(dynamicButton)"
          ></dx-button>
        </div>
      </dxi-item>
    </ng-container>
    <ng-container *ngIf="!locateInMenu">
      <dxi-item location="center" locateInMenu="auto">
        <div class="dynamic-button-container" *ngIf="dynamicButtons && showDynamicButtons">
          <ng-container *ngFor="let dynamicButton of dynamicButtons; trackBy: trackByFn">
            <dx-button
              [style]="dynamicButton?.style"
              [disabled]="(dynamicButton?.disabled ) || (dynamicButton?.donemKontrolYn ? (!donemAktif || !ambarAktif) : false)"
              [text]="dynamicButton?.text"
              [icon]="dynamicButton.icon"
              [type]="dynamicButton.type"
              [hint]="dynamicButton.hint"
              [width]="dynamicButton.width ? dynamicButton.width : 'auto'"
              [stylingMode]="dynamicButton.stylingMode"
              (click)="handleDynamicButtonClick(dynamicButton)"
            ></dx-button>
          </ng-container>
        </div>
      </dxi-item>
    </ng-container>

  </dx-toolbar>
</ng-container>
